import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Regexs } from '@utils/regex';

@Component({
  selector: 'app-personal-interno-involucrado-rol',
  templateUrl: './personal-interno-involucrado-rol.component.html',
  styleUrls: ['./personal-interno-involucrado-rol.component.scss'],
})
export class PersonalInternoInvolucradoRolComponent implements OnInit {
  form: FormGroup;

  @Input() data: { task: any };

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    const { task } = this.data;
    const values = task.data ? task.data : null;
    this.form = this.fb.group({
      descripcion: [values ? values.descripcion : '', [Validators.required]],
      nombre: [values ? values.nombre : '', [Validators.required]],
      cargo: [values ? values.cargo : '', [Validators.required]],
      NM: [values ? values.NM : '', [Validators.required]],
      ci: [
        values ? values.ci : '',
        [Validators.required, Validators.pattern(Regexs.regexCiRif)],
      ],
    });
  }
  verificateInput(value: string) {
    return (
      this.form.get(value)?.invalid &&
      (this.form.get(value)?.dirty || this.form.get(value)?.touched)
    );
  }
}
